<template lang="pug">
  div.compare-utils(v-if="compareIds.length && isLogged" ref="compareUtils" @mousedown="mouseDownHandleelse($event)" @mouseup="mouseUpHandleelse($event)")
    div.title
      div.ids
        label 案例对比
        span {{compareIds.length}}
        | /2
      i.fa.fa-close(@click.prevent="clearCompare")
    div.compare
      div.events
        div.event(v-for="(evt, i) in compareIds" :key="i" :style="{left: `${i * 32}px`}" @mouseover="mouseover(i)" @mouseleave="mouseleave(i)")
          img(:src="evt.imgUrl" @error="defaultImg")
          i.fa.fa-times-circle(v-show="show[i]" @click.prevent="del(evt.id)")
      button(:disabled="compareIds.length < 2" @click="toCompare") 对比
</template>

<script>
import _ from 'lodash'
export default {
  name: 'CompareUtils',
  data () {
    return {
      show: [false, false],
      moveDataelse: {
        x: null,
        y: null
      }
    }
  },
  mounted () {
  },
  computed: {
    compareIds () {
      return this.$store.getters.compareIds
    },
    isLogged () {
      return this.$store.getters.logged
    }
  },
  methods: {
    mouseover (i) {
      this.$set(this.show, i, true)
    },
    mouseleave (i) {
      this.$set(this.show, i, false)
    },
    del (id) {
      let data = _.reject(this.compareIds, d => d.id === id)
      this.$store.dispatch('updateCompareIds', data)
    },
    clearCompare () {
      this.$store.dispatch('updateCompareIds', [])
    },
    mouseDownHandleelse (event) {
      this.moveDataelse.x = event.pageX - this.$refs.compareUtils.offsetLeft
      this.moveDataelse.y = event.pageY - this.$refs.compareUtils.offsetTop
      event.currentTarget.style.cursor = 'move'
      window.onmousemove = this.mouseMoveHandleelse
    },
    mouseMoveHandleelse (event) {
      let moveLeft = event.pageX - this.moveDataelse.x + 'px'
      let moveTop = event.pageY - this.moveDataelse.y + 'px'
      this.$refs.compareUtils.style.left = moveLeft
      this.$refs.compareUtils.style.top = moveTop
    },
    mouseUpHandleelse (event) {
      window.onmousemove = null
      event.currentTarget.style.cursor = 'move'
    },
    toCompare () {
      this.$router.push({
        path: '/comparisonResult',
        query: {
          eventId: this.compareIds[0].id,
          compareEventId: this.compareIds[1].id
        }
      })
      this.clearCompare()
    },
    defaultImg (e) {
      e.target.src = require('@index/assets/img/event_default.png')
    }
  }
}
</script>

<style lang="scss" scoped>
  .compare-utils{
    width: 260px;
    height: 100px;
    background-color: #ffffff;
    border-radius: 4px;
    box-shadow: 0 0 10px rgba(0,0,0,0.1);
    position: fixed;
    right: 20px;
    bottom: 110px;
    cursor: pointer;
    .title{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px;
      .ids{
        color: #999;
        label{
          font-size: 14px;
          color: #333;
        }
        span{
          color: #f87653;
          margin-left: 10px;
        }
      }
      i{
        color: #636666;
      }
    }
    .compare{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 12px;
      height: 60px;
      .events{
        position: relative;
        height: 40px;
        .event{
          position: absolute;
          top: 0;
          z-index: 1;
          cursor: pointer;
          &:hover{
            z-index: 2;
          }
          img{
            width: 40px;
            height: 40px;
            border-radius: 50%;
            border: solid 1px #e8ebf1;
            box-shadow: 0 0 5px rgba(0,0,0,0.06);
          }
          i{
            position: absolute;
            right: 0;
            top: 0;
            color: #3989cb;
          }
        }
      }
      button{
        width: 80px;
        height: 32px;
        background-color: #3989cb;
        border-radius: 4px;
        color: #fff;
        &[disabled] {
          cursor: not-allowed;
          background-color: #ddd;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/components/CompareUtils.vue